"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
// ----------------
// ACTION CREATORS - These are functions exposed to UI components that will trigger a state transition.
// They don't directly mutate state, but they can have external side-effects (such as loading data).
exports.actionCreators = {
    requestZipCodes: function (countyId) { return function (dispatch, getState) {
        // Only load data if it's something we don't already have (and are not already loading)
        var appState = getState();
        //if (appState && appState.rateSearch && countyId !== appState.rateSearch.countyId) {
        return fetch("api/MCWSSearch/GetCountyZipCodes/" + countyId)
            .then(function (response) { return response.json(); })
            .then(function (data) {
            dispatch({ type: 'RECEIVE_ZIPCODES', countyId: countyId, coutyZipCodes: data });
        });
        //dispatch({ type: 'REQUEST_ZIPCODES', countyId: countyId });
        //}
    }; },
    requestSearchResults: function (criteria) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch("api/MCWSSearch/GetSearchResults?age=" + criteria.age + "&gender=" + criteria.gender + "&smoker=" + criteria.smoker + "&zipCode=" + criteria.zipCode + "&insuranceType=" + criteria.insuranceType + "&plans=" + criteria.plans)
                        .then(function (response) { return response.json(); })
                        .then(function (data) {
                        dispatch({ type: 'RECEIVE_SEARCHRESULTS', searchResults: data });
                    })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); }; },
    clearSearch: function () { return function (dispatch, getState) {
        dispatch({ type: 'CLEAR_SEARCH' });
    }; },
    selectCountyInformation: function (countyId, countyName) { return function (dispatch, getState) {
        dispatch({ type: 'SET_COUNTYINFORMATION', countyId: countyId, countyName: countyName });
    }; },
    requestWelcomeText: function () { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var appState;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    appState = getState();
                    if (!(appState && appState.rateSearch && appState.rateSearch.welcomeText.length == 0)) return [3 /*break*/, 2];
                    return [4 /*yield*/, fetch("api/MCWSSearch/GetCWSText/7")
                            .then(function (response) { return response.json(); })
                            .then(function (data) {
                            dispatch({ type: 'RECEIVE_WELCOMETEXT', welcomeText: data });
                        })];
                case 1: return [2 /*return*/, _a.sent()];
                case 2: return [2 /*return*/];
            }
        });
    }); }; },
};
// ----------------
// REDUCER - For a given state and action, returns the new state. To support time travel, this must not mutate the old state.
var unloadedState = {
    countyZipCodes: [], welcomeText: [], isLoading: false, countyName: '', hasSearched: false, criteria: { age: "", gender: "", insuranceType: "", plans: "", smoker: "", zipCode: "" }, searchResults: { rates: [], rateDisplays: [] }
};
exports.reducer = function (state, incomingAction) {
    if (state === undefined) {
        return unloadedState;
    }
    var action = incomingAction;
    switch (action.type) {
        case 'REQUEST_ZIPCODES':
            return {
                countyId: action.countyId,
                countyZipCodes: state.countyZipCodes,
                isLoading: true,
                hasSearched: state.hasSearched,
                criteria: state.criteria,
                searchResults: state.searchResults,
                countyName: state.countyName,
                welcomeText: state.welcomeText
            };
        case 'RECEIVE_ZIPCODES':
            // Only accept the incoming data if it matches the most recent request. This ensures we correctly
            // handle out-of-order responses.
            if (action.countyId === state.countyId) {
                return {
                    countyId: action.countyId,
                    countyZipCodes: action.coutyZipCodes,
                    isLoading: false,
                    hasSearched: state.hasSearched,
                    criteria: state.criteria,
                    searchResults: state.searchResults,
                    countyName: state.countyName,
                    welcomeText: state.welcomeText
                };
            }
            ;
        case 'REQUEST_SEARCHRESULTS':
            return {
                countyId: state.countyId,
                countyZipCodes: state.countyZipCodes,
                isLoading: true,
                hasSearched: state.hasSearched,
                criteria: state.criteria,
                searchResults: state.searchResults,
                countyName: state.countyName,
                welcomeText: state.welcomeText
            };
        case 'RECEIVE_SEARCHRESULTS':
            return {
                countyId: state.countyId,
                countyZipCodes: state.countyZipCodes,
                isLoading: false,
                hasSearched: true,
                criteria: state.criteria,
                searchResults: action.searchResults,
                countyName: state.countyName,
                welcomeText: state.welcomeText
            };
        case 'SET_COUNTYINFORMATION':
            return {
                countyId: action.countyId,
                countyName: action.countyName,
                countyZipCodes: state.countyZipCodes,
                isLoading: state.isLoading,
                hasSearched: state.hasSearched,
                criteria: state.criteria,
                searchResults: state.searchResults,
                welcomeText: state.welcomeText
            };
        case 'CLEAR_SEARCH':
            return __assign(__assign({}, state), { countyId: 0, countyName: '', isLoading: false, hasSearched: false, criteria: {}, searchResults: { rates: [], rateDisplays: [] } });
        case 'RECEIVE_WELCOMETEXT':
            return __assign(__assign({}, state), { welcomeText: action.welcomeText });
        //break;
    }
    return state;
};
//# sourceMappingURL=RateSearch.js.map